const { h, render, Component } = require('preact');

class Number extends Component {
  constructor(props) {
    super(props);
    this.readInput = this.readInput.bind(this)
    this.validateInput = this.validateInput.bind(this)
    this.readInput = this.readInput.bind(this)
    this.isInputGiven = this.isInputGiven.bind(this)
    this.isInputValid = this.isInputValid.bind(this)
    this.populateInput = this.populateInput.bind(this)
    this.changeNumberState = this.changeNumberState.bind(this)
  }

  changeNumberState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.validateInput())
  }

  getInputHtmlElement() {
    var elementId = "number_input" + this.props.attrs.counter
    return document.getElementById(elementId)
  }

  isInputGiven() {
    return this.getInputHtmlElement().value.trim().length > 0
  }

  readInput() {
    return this.getInputHtmlElement().value.trim()
  }

  validateInput() {
    if (this.props.attrs.required  == "true") {
      return this.isInputGiven()
    }
    return true
  }

  isInputValid() {
    return this.isInputGiven()
  }

  populateInput() {
    var data = {}
    if (this.isInputGiven()) {
      var inputData = this.readInput()
      data.description = `\n\n ${this.props.attrs.label} : ${inputData}`
    }
    return data
  }

  componentDidMount() {
    var textLineElement = this.getInputHtmlElement()
    textLineElement.addEventListener("keyup", this.changeNumberState)
  }

  render() {
    let attrs = this.props.attrs
    let maxLength = 250
    let additional_attributes = attrs.additional_attributes
    if (additional_attributes) {
      let max_characters = additional_attributes.maximum_number_of_characters_or_digits
      if (max_characters) {
        if (max_characters.length > 0) {
          maxLength = parseInt(max_characters)
        }
      }
    }

    return(
      <div>
      <label><strong>{attrs.label}</strong>
        {attrs.required == "true"? (<span class="mandatory-field"> * </span>) : null}</label>
      <input class="inputField number_input" size="20" maxLength={maxLength} type="text"  data-bhw={'number_input_' + attrs.counter} aria-label={attrs.label} id = {"number_input" + attrs.counter}/>
      </div>
    )
  }
}


module.exports = Number
